import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { getImgixSrc } from '@utils/images';

export interface TestimonialProps {
  img?: string;
  name: string;
  title?: string;
  quote: string;
}

const Testimonial = ({ img, name, title, quote }: TestimonialProps) => {
  return (
    <div className="w-full max-w-full border-0 border-b-[3px] border-solid border-primary-magenta">
      <div className="pull-quote !mb-0 !mt-0 !min-h-[46px] flex-row !pt-0  text-headline-xs before:!-ml-12 before:!max-h-[46px] before:!min-h-[46px] before:!text-[160px] before:leading-[0.8]" />
      <div className="mt-24 font-suisse-neue text-body-md sm:max-w-[300px] md:mt-16 md:max-w-[440px]">
        {quote}
      </div>
      <LazyImgixImage
        alt="testimonial profile"
        className="h-90 w-90 rounded-full"
        wrapperClassName="mt-24 h-90 w-90"
        src={getImgixSrc({ path: `about/${img}`, isEnvDependent: false })}
      />
      <div className="mt-24 font-suisse-screen">
        <span className="text-byline-lg">{name}</span>
        <span className="text-byline-md text-grayscale-charcoal"> | {title}</span>
      </div>
    </div>
  );
};

export default Testimonial;
